import React, { Component } from 'react';
import { connect } from 'dva';
import { AutoComplete, Button, Icon, Input, Menu, Popover, Select, Tag, Row, Col, message } from 'antd';
import BaseComponent from '../../../components/BaseComponent';
//import {DimioNotice} from '../../../components/Dimio';
import config from '../config/config';

const { travel } = config;
//const Option = AutoComplete.Option;
//const OptGroup = AutoComplete.OptGroup;
//const Option = Select.Option;
//const OptGroup = Select.OptGroup;

class SearchKeyword extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchKeyword: null
    }

    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    //    this.onChange = this.onChange.bind(this);
    //    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  onFocus(e) {
    e.preventDefault();
    this.suggest.tooltip.setState({ visible: false });
  }

  /*
  onSelect(item, key, selectedKey){
    const {dispatch} = this.props;
    console.info('select', item.item.props);
//    this.search(item.item.props.title);
//    this.suggest.visible = false;
    const q = item.item.props.title;

    //this.setState({searchKeyword: q});
//    this.suggest.visible = false;

    this.suggest.tooltip.setState({visible:false});

    console.info(this.suggest);
    console.info(this.suggest.tooltip);

    this.input.input.input.value = q;

    dispatch({
      type: 'search/searchKeyword',
      keyword: q
    });
  }
  */

  onSelect(e, opt) {
    const { dispatch } = this.props;
    e.preventDefault();

    this.suggest.tooltip.setState({ visible: false });
    this.searchBox.input.input.value = opt.name;

    /*
    console.info('select', item.item.props);
//    this.search(item.item.props.title);
//    this.suggest.visible = false;
    const q = item.item.props.title;

    //this.setState({searchKeyword: q});
//    this.suggest.visible = false;


    console.info(this.suggest);
    console.info(this.suggest.tooltip);

    dispatch({
      type: 'search/searchKeyword',
      keyword: opt.name
    });
*/

    this.search(opt.name);
  }

  /*
    onBlur(){
      console.info('blur');
    }
  */
  onSearch(q, e) {
    console.info('search', q);

    if (q.length == 0) {
      //this.showError('キーワードを入力してください');
      message.info('キーワードを入力してください');
      return;
    }

    this.search(q);
  }

  search(q) {
    const { dispatch } = this.props;

    q = q.replace(/　/g, ' ');

    const query = { q: q };
    const self = this;

    const opt = {
      query: query,
      onSuccess({ data, meta }) {
        //        console.info(data);
        dispatch({
          type: 'search/search',
          items: data,
          keyword: q
          //          meta: meta
        });

      },
      onError(error) {
        console.info(error);
      }
    }

    this.load(travel.api.travelSearch, opt);
  }

  render() {
    const { search: { suggestions, searchKeyword } } = this.props;
    //    const searchKeyword = (this.state.searchKeyword)?this.state.searchKeyword:this.props.defaultValue;
    console.info('Search Keyword', searchKeyword);
    if (this.searchBox) {
      this.searchBox.input.input.value = searchKeyword;
    }

    const options = (
      <div className='container select-city__container'>
        <div className='select-city position-relative'>
          <Button type='circle' icon='close' onClick={this.onFocus} className='position-absolute' />
          <div className='select-city__title'>都市から探す</div>
          <Row gutter={16}>
            {suggestions && suggestions.map(opt => (
              <Col xs={12} sm={8} key={opt.key}>
                <a className='select-city__item' href='#' onClick={e => this.onSelect(e, opt)}>
                  {opt.name} <span>({opt.cnt})</span>
                </a>
              </Col>
            ))}
          </Row>
          {/*
        <Menu onSelect={this.onSelect}>
          {suggestions && suggestions.map(opt => (
            <Menu.Item key={opt.key} title={opt.name} className='m-0'>{opt.name}</Menu.Item>
          ))}
        </Menu>
        */}
        </div>
      </div>
    );

    return (
      <div>
        {suggestions &&
          <Popover
            content={options}
            placement="bottom"
            ref={ref => {
              this.suggest = ref
            }}
            trigger="click">
            <Input.Search
              className="search-box"
              placeholder="検索"
              defaultValue={searchKeyword}
              onSearch={this.onSearch}
              onKeyUp={this.onFocus}
              //            onChange={this.onChange}
              enterButton='検索する'
              ref={ref => { this.searchBox = ref }}
            />
          </Popover>
        }
      </div>
    )
  }
}

export default connect(({ search }) => ({
  search
}))(SearchKeyword);



// WEBPACK FOOTER //
// ./src/pages/search/components/SearchKeyword.js